// extracted by mini-css-extract-plugin
module.exports = {"button":"jgp-g3jCK","disabled":"jgp-1bzuK","icon":"jgp-XdHto","animatedButton":"jgp-2VXMo","pulse":"jgp-rhHx9","brandedAnimationButton":"jgp-13XA0","brandedPulse":"jgp-3XnZm"};